/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_DescriptionInputs */

const zh_billing_description = /** @type {(inputs: Billing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看订阅记录和管理付款方式。`)
};

const en_billing_description = /** @type {(inputs: Billing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View subscription history and manage payment methods.`)
};

const es_billing_description = /** @type {(inputs: Billing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver historial de suscripciones y gestionar métodos de pago.`)
};

/**
* | output |
* | --- |
* | "View subscription history and manage payment methods." |
*
* @param {Billing_DescriptionInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const billing_description = /** @type {((inputs?: Billing_DescriptionInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_DescriptionInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_billing_description(inputs)
	if (locale === "en") return en_billing_description(inputs)
	return es_billing_description(inputs)
});